import { useQuery } from "@tanstack/react-query";
import { SCHOOL_LAB_POC } from "../../apiRoutes";
import axiosAuth from "../../../axiosAuth";

interface SchoolPoc {
  id: string;
  pocName: string;
  pocDesignation: string;
  pocDepartment?: string;
  pocPhone: string;
  pocEmail: string;
  schoolId: string;
}

interface GetSchoolPocsResponse {
  success: boolean;
  message: string;
  data: SchoolPoc[];
}

export const useGetSchoolPocsQuery = (schoolId: string, options?: {
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ["schoolPocs", schoolId],
    queryFn: async (): Promise<GetSchoolPocsResponse> => {
      const response = await axiosAuth.get(SCHOOL_LAB_POC + schoolId + "/");
      return response.data;
    },
    enabled: options?.enabled ?? !!schoolId,
  });
};
